import { useState, useCallback, useMemo } from "react";
import BreakdownDialog from "./BreakdownDialog";
import { assetTypeValues } from "../../../constants";

export const FLEET_MIX_BREAKDOWN_COLUMNS = [
  { key: "lease_ref_code", label: "Lease Ref Code" },
  { key: "lessee", label: "Lessee" },
  { key: "aircraft_type", label: "Aircraft Type" },
  { key: "asset_label", label: "Asset" },
];

function buildFleetMixRows(items) {
  if (!Array.isArray(items)) return [];
  return items.map((item, index) => ({
    id: `${item?.lessee || "lessee"}-${item?.lease_ref_code || "lease"}-${index}`,
    lessee: item?.lessee || "-",
    aircraft_type: item?.aircraft_body_type || "",
    lease_ref_code: item?.lease_ref_code || "-",
    asset_label: [assetTypeValues[item?.asset_type]?.label, item?.asset_sn].filter(Boolean).join(" ") || "-",
  }));
}

// Clicking any segment of a lessee's bar opens fleet_mix_breakdown filtered to that lessee.
export function useFleetMixByLesseeBreakdown({ fleetMixBreakdown, onTrack }) {
  const [selectedLessee, setSelectedLessee] = useState(null);
  const reset = useCallback(() => setSelectedLessee(null), []);

  const allRows = useMemo(() => buildFleetMixRows(fleetMixBreakdown), [fleetMixBreakdown]);
  const rows = useMemo(
    () => (selectedLessee ? allRows.filter((row) => row.lessee === selectedLessee) : []),
    [allRows, selectedLessee],
  );

  const chartEvents = useMemo(() => ({
    click: (params) => {
      if (params?.componentType !== "series") return;
      setSelectedLessee(params.name);
      onTrack?.(`Graph Bar Clicked: ${params.name}`);
    },
  }), [onTrack]);

  return { rows, canRender: allRows.length > 0, chartEvents, modalOpen: !!selectedLessee, closeModal: reset, titleSuffix: selectedLessee || "", reset };
}

export function FleetMixByLesseeBreakdownModal({ open, onClose, rows, titleSuffix }) {
  const title = "Fleet Mix Exposure by Lessee";
  const rowCount = Array.isArray(rows) ? rows.length : 0;
  const countLabel = `${rowCount} ${rowCount === 1 ? "Asset" : "Assets"}`;
  const subtitle = titleSuffix ? `${titleSuffix}  (${countLabel})` : countLabel;
  return (
    <BreakdownDialog
      open={open}
      onClose={onClose}
      title={title}
      subtitle={subtitle}
      exportFileName={titleSuffix ? `${title} - ${titleSuffix}` : title}
      columns={FLEET_MIX_BREAKDOWN_COLUMNS}
      rows={rows}
    />
  );
}
